module.exports = __webpack_public_path__ + "static/img/sass.70a76991.png";